/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechPowerButtonIcon64Regular = forwardRef('TechPowerButtonIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M33.5 4.5a1.5 1.5 0 0 0-3 0v24a1.5 1.5 0 0 0 3 0v-24Z" }),
        React.createElement("path", { d: "M20.5 12.081A1.5 1.5 0 1 0 19 9.483a26 26 0 1 0 26 0 1.5 1.5 0 0 0-1.5 2.598 23 23 0 1 1-23 0Z" })));
});
